// extracted by mini-css-extract-plugin
export var cell = "_74-4";
export var headerCell = "_74-2";
export var rowHeader = "_74-3";
export var table = "_74-1";
export var tableContainer = "_74-0";